import React from 'react';

export type MerchantDetailTabKey =
  | 'general'
  | 'menu'
  | 'analytics'
  | 'paymentMethods';

export interface MerchantDetailTabItem {
  key: MerchantDetailTabKey;
  label: string;
  icon: React.ReactNode;
  children: React.ReactNode;
}

interface MerchantDetailTabsProps {
  activeKey: MerchantDetailTabKey;
  onChange: (key: MerchantDetailTabKey) => void;
  items: MerchantDetailTabItem[];
}

export const MerchantDetailTabs: React.FC<MerchantDetailTabsProps> = ({
  activeKey,
  onChange,
  items,
}) => {
  const activeItem = items.find(t => t.key === activeKey);

  return (
    <div className="merchant-detail-tabs">
      <div className="merchant-detail-tabs-list" role="tablist">
        {items.map(item => (
          <button
            key={item.key}
            type="button"
            role="tab"
            aria-selected={activeKey === item.key}
            className={`merchant-detail-tab ${
              activeKey === item.key ? 'merchant-detail-tab-active' : ''
            }`}
            onClick={() => onChange(item.key)}
          >
            <span className="merchant-detail-tab-icon">{item.icon}</span>
            <span className="merchant-detail-tab-label">{item.label}</span>
          </button>
        ))}
      </div>
      <div className="merchant-detail-tabs-panel" role="tabpanel">
        {activeItem?.children}
      </div>
    </div>
  );
};
